import { render } from "./p-color-picker.vue?vue&type=template&id=5c023141&scoped=true"
import script from "./p-color-picker.vue?vue&type=script&lang=js"
export * from "./p-color-picker.vue?vue&type=script&lang=js"

import "./p-color-picker.vue?vue&type=style&index=0&id=5c023141&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c023141"]])

export default __exports__